import React from 'react';
import { Card, CardActionArea, CardMedia, Typography, Link, Grid } from '@mui/material';
import { withStyles } from 'tss-react/mui';

const styles = theme => ({
    imageCard: {
        margin: theme.spacing(0.5)
    },
    imageCardMedia: {
        '& h6': {
            display: 'none'
        },
        '&:hover': {
            '& h6': {
                display: 'block'
            }
        }
    },
    imageAuthorLabel: {
        position: 'absolute',
        bottom: theme.spacing(0),
        background: '#00000061',
        width: '100%',
        padding: theme.spacing(0.5)
    }
});

const MediaPickerImageCard = (props) => {
    const { classes, image, onImageClick, galleryCardWidth, galleryCardHeight } = props;

    return (
        <Grid>
            <Card 
                className={classes.imageCard}
                style={{width: galleryCardWidth}}
                onClick={() => onImageClick(image)}
            >
                <CardActionArea>
                    <CardMedia
                        className={classes.imageCardMedia}
                        style={{height: galleryCardHeight}}
                        image={image.thumbnailUrl}
                        title={image.title}
                        children={image.author && (
                            <Typography 
                                className={classes.imageAuthorLabel} 
                                variant='subtitle2' 
                                color='textSecondary'
                            >
                                <Link 
                                    href={image.authorUrl} 
                                    target='_blank' 
                                    color='textSecondary' 
                                >
                                    {image.title}
                                </Link>
                            </Typography>
                        )}
                    />
                </CardActionArea>
            </Card>
        </Grid>
    );
}

export default withStyles(MediaPickerImageCard, styles);